/* born native v7 — scroll interactions. No libraries; everything degrades to a static page. */
(function () {
  var doc = document.documentElement;
  doc.classList.add('bn7-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;
  /* Horizon may scroll .page-wrapper instead of the window */
  var scroller = (function () {
    var pw = document.querySelector('.page-wrapper');
    if (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) return pw;
    return null;
  })();
  function sy() { return scroller ? scroller.scrollTop : window.scrollY; }

  /* Split headings into lines for the mask reveal: each <br> or "|" starts a new line */
  document.querySelectorAll('[data-bn7-lines]').forEach(function (el) {
    if (el.dataset.bn7Split) return;
    el.dataset.bn7Split = '1';
    var parts = el.innerHTML.split(/<br\s*\/?>|\s\|\s/i);
    el.innerHTML = parts.map(function (p, i) { return '<span><span style="--i:' + i + '">' + p.trim() + '</span></span>'; }).join('');
  });

  /* Reveal on enter */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { root: scroller, rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  var revealEls = [].slice.call(document.querySelectorAll('[data-bn7-reveal],[data-bn7-lines],[data-bn7-wipe]'));
  revealEls.forEach(function (el) {
    if (io && !reduce) io.observe(el); else el.classList.add('is-in');
  });
  /* safety net: never leave on-screen content hidden if the observer is late or missing */
  function revealSeen() {
    var vh = window.innerHeight;
    revealEls = revealEls.filter(function (el) {
      if (el.classList.contains('is-in')) return false;
      if (el.getBoundingClientRect().top < vh) { el.classList.add('is-in'); return false; }
      return true;
    });
  }
  setTimeout(revealSeen, 2500);

  /* Home header: transparent over the hero, solid after it */
  var hero = document.querySelector('.bn7-hero');
  if (hero) {
    body.classList.add('bn7-home');
    var setHH = function () {
      var h = 0;
      document.querySelectorAll('#header-group > .shopify-section').forEach(function (el) { h += el.offsetHeight; });
      body.style.setProperty('--bn7-hh', h + 'px');
    };
    setHH(); window.addEventListener('resize', setHH); window.addEventListener('load', setHH);
    var hc = document.getElementById('header-component'), hot = false;
    var setIdle = window.bn7SetIdle = function () {
      /* only top-level menus count: Horizon keeps submenus inside the closed mobile drawer [open] */
      var open = hc && [].some.call(hc.querySelectorAll('[aria-expanded="true"], details[open]'), function (el) {
        var d = el.parentElement && el.parentElement.closest('details');
        return !d || d.open;
      });
      body.classList.toggle('bn7-hdr-idle', !hot && !open && !body.classList.contains('bn7-scrolled'));
    };
    if (hc) {
      hc.addEventListener('mouseenter', function () { hot = true; setIdle(); });
      hc.addEventListener('mouseleave', function () { hot = false; setTimeout(setIdle, 250); });
      hc.addEventListener('focusin', function () { hot = true; setIdle(); });
      hc.addEventListener('focusout', function () { hot = false; setTimeout(setIdle, 250); });
      new MutationObserver(setIdle).observe(hc, { subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'open'] });
    }
    setIdle();
  }

  /* Sticky scenes */
  var origins = [].slice.call(document.querySelectorAll('.bn7-origin'));
  var looks = [].slice.call(document.querySelectorAll('.bn7-look'));
  var parallax = [].slice.call(document.querySelectorAll('[data-bn7-parallax], .bn7-hero__media, .bn7-phero__media'));

  function sizeLooks() {
    looks.forEach(function (s) {
      var track = s.querySelector('.bn7-look__track');
      if (!track) return;
      if (window.innerWidth < 750 || reduce) { s.style.height = ''; s._dist = 0; return; }
      var dist = Math.max(0, track.scrollWidth - window.innerWidth);
      s._dist = dist;
      s.style.height = (window.innerHeight + dist) + 'px';
    });
  }

  var ticking = false;
  var setIdle = window.bn7SetIdle || function () {};
  function frame() {
    setIdle = window.bn7SetIdle || setIdle;
    ticking = false;
    var vh = window.innerHeight, y = sy();
    if (hero) { body.classList.toggle('bn7-scrolled', y > Math.max(80, hero.offsetHeight - 90)); setIdle(); }
    if (revealEls.length && started) revealSeen();
    if (reduce) return;
    origins.forEach(function (s) {
      var r = s.getBoundingClientRect();
      var total = s.offsetHeight - vh;
      var p = Math.min(1, Math.max(0, -r.top / total));
      var e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      s.style.setProperty('--p', p.toFixed(4));
      s.style.setProperty('--p2', Math.max(0, (p - .6) / .4).toFixed(4));
      /* mask height grows from 26vh until the cross arms are wider than the screen */
      var maxH = Math.max(vh * 14, window.innerWidth * 9);
      s.style.setProperty('--ms', (vh * .26 + e * maxH).toFixed(0) + 'px');
    });
    looks.forEach(function (s) {
      if (!s._dist) return;
      var r = s.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -r.top / (s.offsetHeight - vh)));
      s.style.setProperty('--tx', (-p * s._dist).toFixed(1) + 'px');
      s.style.setProperty('--lp', p.toFixed(4));
    });
    parallax.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 50) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.setProperty('--py', (c * -6).toFixed(2) + '%');
    });
    if (hero) {
      var hp = Math.min(1, Math.max(0, y / hero.offsetHeight));
      hero.style.setProperty('--hs', (1 + hp * .12).toFixed(4));
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  var started = false;
  sizeLooks(); frame(); started = true;
  (scroller || window).addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { sizeLooks(); onScroll(); });
  window.addEventListener('load', function () { sizeLooks(); onScroll(); });

  /* Local time at the brand coordinates (Central European Time) */
  document.querySelectorAll('[data-bn7-clock]').forEach(function (el) {
    function tick() {
      try { el.textContent = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' }).format(new Date()) + ' CET'; } catch (e) {}
    }
    tick(); setInterval(tick, 20000);
  });

  /* Filter labels were set up in Russian in Search & Discovery (TAILROAD era): show them in English */
  var bnLabels = { 'Доступность': 'Availability', 'Цена': 'Price', 'Размер': 'Size', 'Цвет': 'Colour', 'Тип продукта': 'Type', 'Тип товара': 'Type', 'Поставщик': 'Brand', 'Бренд': 'Brand', 'Материал': 'Material', 'В наличии': 'In stock', 'Нет в наличии': 'Out of stock' };
  function bnTranslate(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) { var k = n.nodeValue.trim(); if (bnLabels[k]) n.nodeValue = n.nodeValue.replace(k, bnLabels[k]); }
  }
  bnTranslate();
  new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (x) { if (x.nodeType === 1) bnTranslate(x); }); }); }).observe(document.body, { childList: true, subtree: true });

  /* Add to bag opens the cart drawer instead of leaving the product page; any failure falls back to the normal form post */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('.bn7-pdp form[action*="/cart/add"]')) return;
    var drawer = document.querySelector('cart-drawer-component');
    var td = drawer && drawer.closest('theme-drawer');
    if (!td || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    var fd = new FormData(f);
    fd.append('sections', 'cart-drawer-section');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (j) {
        var html = j.sections && j.sections['cart-drawer-section'];
        var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer-component');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var icon = document.querySelector('cart-icon');
        if (icon && icon.renderCartBubble) icon.renderCartBubble(cart.item_count);
        if (btn) btn.disabled = false;
        td.open();
      })
      .catch(function () { f.submit(); });
  });

  /* Product filter chips */
  document.querySelectorAll('[data-bn7-filter]').forEach(function (wrap) {
    var chips = wrap.querySelectorAll('.bn7-chip');
    var cards = wrap.querySelectorAll('.bn7-card[data-group]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var g = chip.dataset.group;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        cards.forEach(function (card) { card.hidden = !(g === 'all' || card.dataset.group === g); });
      });
    });
  });
})();
